"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    staticClass: "el-card",
    "class": _vm.shadow ? 'is-' + _vm.shadow + '-shadow' : 'is-always-shadow',
    attrs: {}
  }, [_vm.$slots.header || _vm.header ? _c('div', {
    staticClass: "el-card__header",
    attrs: {}
  }, [_vm._t("header", [_vm._v(_vm._s(_vm.header))], {})], 2) : _vm._e(), _vm._v(" "), _c('div', {
    "class": ['el-card__body', _vm.bodyClass],
    style: _vm._px2rem(_vm.bodyStyle, 24, []),
    attrs: {}
  }, [_vm._t("default", null, {})], 2)]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElCard',
  props: {
    header: {},
    bodyStyle: {},
    bodyClass: {
      type: String,
      "default": ''
    },
    shadow: {
      type: String
    }
  }
};
exports["default"] = _default;